export type SelectOption = {
  label: string;
  value: string | number;
};

export const mapToSelectOptions = <T extends Record<string, any>>(
  items: T[],
  config: {
    label: keyof T | ((item: T) => string);
    value?: keyof T | ((item: T) => string | number);
  },
): SelectOption[] => {
  return items.map((item) => ({
    label: typeof config.label === 'function' ? config.label(item) : String(item[config.label]),

    value: typeof config.value === 'function' ? config.value(item) : config.value ? item[config.value] : item.id,
  }));
};
